// list of applicable user roles in the system
export enum UserRoleEnum {
  Admin = 'admin',
  Creator = 'creator',
  Viewer = 'viewer',
}
